<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="judge">
        <router-link :to="{path:'/mycenter',query:{roleId:userid}}">
          <el-page-header>
          </el-page-header>
        </router-link>
        <div class="content">
          <el-steps :active="active" finish-status="success" simple>
            <el-step title="步骤 1" icon="el-icon-edit"></el-step>
            <el-step title="步骤 2" icon="el-icon-picture"></el-step>
            <el-step title="步骤 3" icon="el-icon-s-promotion"></el-step>
          </el-steps>

          <ul class="companyverify" v-if="active == 0">
            <li class="companyitem"><span>
                <el-input placeholder="请输入公司名称" v-model="companyname">
                  <i slot="prefix"><img class="ico1" src="../assets/images/company_ico.png" /></i>
                </el-input>
              </span>

            </li>
            <img class="ico" src="../assets/images/company_ico.png" /><span class="simplecompany">公司简介</span>
            <li class="companyitem">

              <el-input class="companydescription" type="textarea" resize="none" autosize placeholder="请输入公司简介" v-model="companydescription" maxlength="500" :autosize="{ minRows: 8, maxRows: 8}">

              </el-input>
            </li>
            <!-- <li class="company">
              <div class="icotext"><img class="ico" src="../assets/images/company_ico.png">公司名称</div><span>上海卫平有限公司</span>
            </li>
            <li class="companyintroduction">
              <div class="icotext"><img class="ico" src="../assets/images/company_ico.png">公司简介</div>
              <div class="introduction">hhhhhhhhhhhhhhhhh</div>
            </li> -->
 <img class="ico" src="../assets/images/company_ico.png" /><span class="simplecompany">公司图片</span>
           
<el-upload action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile" :on-success="updatepicture" multiple :limit="5" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" list-type="picture-card" :on-change="ChangeImage" :class="{ hide: hideUpload }"  :file-list="fileList"
 >  <i slot="default" class="el-icon-plus"></i>
                 <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                   <span  class="el-upload-list__item-delete" @click="handleRemove(file,fileList)">
                    <i class="el-icon-delete"></i>
                  </span>
                  </span>
                 </div>
                    <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
              </el-upload>
               <li><el-button type="primary" @click="messagechange()">下一步</el-button>
            </li>
          </ul>
          <ul v-if="active == 1">
            <li class="uploadpart"> <img src="../assets/images/deleteimg_ico .png" class="del" @click="del1" v-if="(this.imageUrl4)">
              <el-upload class="upload-demo" :data="multipartFile" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" :on-success="updatepicture4">
                <img v-if="!this.imageUrl4" class="upload" :src="baseImg4"><img class="uploaded" v-else :src="imageUrl4">
                <div class="tips" v-if="!(this.imageUrl4)">请上传营业执照</div>
              </el-upload>
            </li>
            <li class="uploadpart">
              <div class="a_tips" v-if="!(this.imageUrl5)"><a href="
https://ringstar.xhqj71.com/jeecg-boot/sys/common/static//test.docx" class="a_tips">下载模板样式</a></div><img src="../assets/images/deleteimg_ico .png" class="del" @click="del2" v-if="(this.imageUrl5)">
              <el-upload class="upload-demo" :data="multipartFile" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" :on-success="updatepicture5"><img class="upload" v-if="!(this.imageUrl5)" :src="baseImg5" >
                <img class="uploaded" v-else :src="imageUrl5">
                <div class="tips" v-if="!(this.imageUrl5)">请上传授权书照片</div>
                <span class="tips" id="error" v-if="!(this.imageUrl5)"><img class="error" src="../assets/images/error_ico.png">法人本人无需上传</span>
              </el-upload>
            </li>
            
            <li class="buttons">
              <el-button type="primary" @click="previous()">上一步</el-button>
              <el-button type="primary" @click="submitverify()">企业认证提交</el-button>
            </li>
          </ul>
          <ul v-if="active == 2">
            <el-result icon="success" title="提示" subTitle="提交成功，等待后台审核">
              <template slot="extra">
                <router-link :to="{path:'/mycenter',query:{roleId:userid}}">
                  <el-button type="primary" size="medium">返回</el-button>
                </router-link>
                <el-button type="primary" @click="previous()">上一步</el-button>
              </template></el-result>
          </ul>
        </div>
      </div>

    </div>
  </div>

</div>
</template>

<script>
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
import transparentheaders from "../components/transparentheaders.vue";
import {
  companyVerify,
  queryById
} from "../api/api";
export default {
  data() {
    return {
      companydescription: "",
      companyname: "",
      msg: "",
      active: 0,
      imageUrl4: "",
      imageUrl5: "",
      userid: "",
      multipartFile: {
        biz: "app_personPic"
      },
      baseImg4: require('../assets/images/uploads_ico.png'),
      baseImg5: require('../assets/images/uploads_ico.png'),
      imageUrl4: '',
      imageUrl5: '',
      pic4: "",
      pic5: "",
      dialogVisible: false,
      hideUpload: "",
      dialogImageUrl: '',
       imgs: [],
      img: [],
      fileList: [],
    }
  },
  components: {
    transparentheaders
  },
  created() {
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id
  },
  mounted() {
    queryById({
      id: this.userid
    }).then(res => {
      if (res.data.code == 200) {
        this.companyname = res.data.result.company;
        this.companydescription = res.data.result.companyDesc;
        if (res.data.result.pic4)
        {
          this.pic4 = res.data.result.pic4;
          this.imageUrl4 = imgUrl + res.data.result.pic4;
        }
         
        if (res.data.result.pic5)
          {
          this.pic5 = res.data.result.pic5;
          this.imageUrl5 = imgUrl + res.data.result.pic5;
        }

      }
    });
  },
  methods: {
     handleRemove(file, fileList) {

      const index = this.fileList.findIndex((item) => {
        return item.uid === file.uid
      })
      this.fileList.splice(index, 1)
      this.imgs.splice(index, 1)
      this.img.splice(index, 1)
      this.hideUpload = false
    },
     handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    messagechange() {

      if (!(this.companydescription)) {
        this.msg = "请填写公司简介";
        this.open()
      }
      if (!(this.companyname)) {
        this.msg = "请填写公司名称";
        this.open()
      }
      if ((this.companydescription) && (this.companyname)) {
        this.next();
      }
    },
    ChangeImage(file, fileList) {
         console.log(fileList);
         this.hideUpload =  fileList.length > 4;
         
    
    },
    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {
        // if (this.msg === "注册成功") {
        //   this.$router.push({
        //     path: "/"
        //   });
        // }
      });
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    previous() {
      this.active--;
    },
    updatepicture4(res) {
      const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
      this.pic4 = res.message
      this.imageUrl4 = imgUrl + res.message
    },
    updatepicture5(res) {
      const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
      this.pic5 = res.message
      this.imageUrl5 = imgUrl + res.message
    },
    submitverify() {
      if (!(this.imageUrl4)) {
        this.msg = "请上传营业执照";
        this.open()
      }
      if (this.imageUrl4) {
        let data = {
          company: this.companyname,
          companyDesc: this.companydescription,
          id: this.userid,
          pic4: this.pic4,
          pic5: this.pic5,
          companyPic1: this.imgs[0] ? this.imgs[0] : '',
          companyPic2: this.imgs[1] ? this.imgs[1] : '',
          companyPic3: this.imgs[2] ? this.imgs[2] : '',
          companyPic4: this.imgs[3] ? this.imgs[3] : '',
          companyPic5: this.imgs[4] ? this.imgs[4] : '',
        }
        companyVerify(data).then(res => {
          if (res.data.code == 200) {
            this.next();
          }
        });
      }

    },
    del1() {
      this.imageUrl4 = ""
    },
    del2() {
      this.imageUrl5 = ""
    },
    updatepicture(res) {
      this.imgs.push(res.message)
      this.img.push(imgUrl + res.message)
      this.fileList = this.img.map(item => {
        return {
          name: item,
          url: item
        }
      });

      // if (!this. companyPic1) {
      //   this. companyPic1 = res.message
      //   return
      // }
      // if (!this.companyPic2) {
      //   this.companyPic2 = res.message
      //   return
      // }
      // if (!this.companyPic3) {
      //   this.companyPic3 = res.message
      //   return
      // }
      // if (!this.companyPic4) {
      //   this.companyPic4 = res.message
      //   return
      // }
      // if (!this.companyPic5) {
      //   this.companyPic5 = res.message
      //   return
      // }
      
    },
  }
}
</script>

<style lang="scss" scoped>
.background {
  padding: 20px;
  background: rgb(234, 242, 250);
}

.white {
  background: white;
}

.a_tips {
  font-size: 11px;

  text-align: right !important;
  color: #2c97e9;
  cursor: pointer;

}

li {
  text-align: center;
}

.judge {

  margin-top: 70px;
  padding: 20px;
  background: white;
  min-height: 90vh;
}

.companyintroduction {

  margin-bottom: 30px;
  margin: 20px 0;
  padding: 18px 20px;
  border-radius: 5px;
  box-shadow: 1px 1px 8px 2px rgba(171, 192, 214, .2);
}

.content {
  padding: 120px 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.companyverify {
  margin-top: 80px;
}

.ico {
  margin-left: 8px;
  width: 20px;
  height: 20px;
}

.ico1 {
  margin-left: 5px;
  margin-top: 10px;
  width: 20px;
  height: 20px;
}

.icotext {
  margin-right: 240px;
}

.introduction {
  margin-top: 10px;
  margin-bottom: 300px;
}

.el-button {
  background-color: rgb(10, 108, 255);
  border-radius: 20px;
  width: 125px;
}

>>>.el-input__inner {
  background-color: #f2f9ff;
  border: none;
  border-radius: 10px;
}

>>>.el-input--prefix .el-input__inner {
  padding-left: 35px;
}

>>>.el-textarea__inner {
  background-color: #f2f9ff;
  border: none;
  border-radius: 10px;

}

.companyitem {
  margin-bottom: 15px;
}

.upload {
  height: 75px;
  width: 75px;
}

.uploaded {
  height: 150px;
  width: 225px;
}

.uploadpart {
  box-shadow: 1px 1px 8px 2px rgba(171, 192, 214, .2);
  border-radius: 10px;
  margin-top: 25px;
  background-color: #fff;

  padding: 20px;
}

.tips {
  color: grey;
  font-size: 11px;
  margin-top: 10px;
}

#error {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #ea2828;

  font-size: 11px;
}

.error {
  margin-right: 5px;
  width: 15px;
  height: 15px;
}

.buttons {
  margin-top: 60px
}

.simplecompany {
  font-size: 14px;
  margin-left: 5px;
}

>>>.el-upload-list__item {
  // display: none;
}

>>>.el-upload-list__item-name {
  transition: none !important;
  display: none;
}
>>>.el-upload-list__item.is-uploading {
  display: none;
}

>>>.el-upload-list__item.is-ready {
  display: none;
}

>>>.el-upload-list__item {
  transition: none !important;
}
>>>.el-upload-list__item .el-icon-upload-success {
  display: none;
}

.del {
  transform: translateY(20px) translateX(115px);
  cursor: pointer;
}
>>>.el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    cursor: pointer;
    line-height: 100px;
    vertical-align: top;
    margin-top: 10px;
    margin-bottom: 30px;
    
}
    >>>.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
   margin-top: 10px;
    margin-bottom: 30px;
}
>>>.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;

}

</style>
<style>
.hide .el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/companyverify.vue